export default __webpack_public_path__ + "fabric_wrapped_hembar.png";